import React, { Component } from "react";
import { alert, loading, t } from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";

import HomeNavbar from "./components/HomeNavbar.js";
import HomeFooter from "./components/HomeFooter.js";
import HomePropertyCard from "./components/HomePropertyCard.js";

import { loadHomeContent, loadFavoriteProperties } from "./api.js";
import { favList, favToggle, favRemove, favClear, favSubscribe } from "./fav_store.js";
import { openFreePost } from "./options.js";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
import "../../assets/css/homepage.css";

/* ============================================================================
 * FavoriteList — ทรัพย์ที่ผู้ใช้กดหัวใจไว้ (/favorites)
 *
 * เปิดจากปุ่ม "รายการโปรด" บนเมนู ซึ่งเปิดเป็นแท็บใหม่เหมือนการ์ดทรัพย์และปุ่ม
 * ดูทั้งหมด — ผู้ใช้ที่กำลังไล่ดูอยู่จะได้ไม่เสียตำแหน่งที่เลื่อนค้างไว้
 *
 * ตัวรายการเก็บเป็น uid ที่เครื่องผู้ใช้ (fav_store) ไม่ได้ผูกกับบัญชี เพราะยัง
 * ไม่มีระบบสมาชิกฝั่งลูกค้า หน้านี้จึงเอา uid ไปขอข้อมูลจริงกลับมาทุกครั้งที่เปิด
 * แทนการเก็บข้อมูลทรัพย์ทั้งก้อนไว้ที่เครื่อง — ราคา/สถานะที่เห็นจึงเป็นของวันนี้
 * ไม่ใช่ของวันที่กดบันทึก และประกาศที่ถูกปิดไปแล้วจะไม่ค้างอยู่ในรายการ
 * ========================================================================== */
class FavoriteList extends Component {
  state = {
    items: [],
    contact: null,
    ready: false,
  };

  componentDidMount() {
    document.title = `${t("home_favorites")} | SafeSpace Life Living`;
    window.scrollTo({ top: 0 });

    this.Get();
    this.GetOptions();
    this.unsubscribeFav = favSubscribe(this.syncFromStore);
  }

  componentWillUnmount() {
    this.unsubscribeFav();
  }

  Get = async () => {
    const uids = favList();
    /* ตัวหมุนโหลด (#loading ใน index.js) ขึ้นคลุมทั้งจอมาตั้งแต่เปิดเว็บ ทุกหน้าต้องสั่งปิดเอง
       แม้ทางที่ไม่ได้ยิง API — ปุ่มรายการโปรดเปิดเป็นแท็บใหม่ทุกครั้ง คนที่ยังไม่เคยกดหัวใจ
       จึงเจอฉากทึบค้างคาหน้าและกดอะไรไม่ได้เลย ถ้าปล่อยให้ return ออกไปเฉย ๆ */
    if (!uids.length) {
      loading(false);
      return this.setState({ items: [], ready: true });
    }

    loading(true);
    const { items, missing } = await loadFavoriteProperties(uids);
    loading(false);

    this.setState({ items, ready: true }, () => {
      /* uid ที่ API ไม่คืนมา = ประกาศถูกปิด ถูกเก็บเข้าคลัง หรือถูกลบไปแล้ว
         ล้างออกจากเครื่องเลย ไม่งั้นค้างเป็นขยะถาวรและตัวเลขบนเมนูจะไม่ตรงกับ
         จำนวนการ์ดที่เห็นจริง (ล้างหลัง setState เพื่อให้ syncFromStore ที่ถูก
         ปลุกจากการล้างอ่าน items ชุดใหม่ ไม่ใช่ชุดเดิมแล้วสั่งโหลดซ้ำ) */
      if (missing.length) {
        favRemove(missing);
        alert("", "info", t("home_favorites"), t("home_favorites_gone").replace("{n}", missing.length), t("confirm"));
      }
    });
  };

  /* ฟุตเตอร์ใช้ข้อมูลติดต่อชุดเดียวกับหน้าแรก โหลดแยกจากรายการเพราะไม่เกี่ยวกัน */
  GetOptions = async () => {
    const content = await loadHomeContent();
    this.setState({ contact: content.contact });
  };

  /* รายการโปรดเปลี่ยน (กดหัวใจในหน้านี้ หรือไปกดที่แท็บอื่น)
     - มี uid ที่ยังไม่มีข้อมูลบนหน้า = เพิ่งถูกเพิ่มมาจากที่อื่น ต้องขอข้อมูลใหม่
     - นอกนั้นเป็นการเอาออก ตัดการ์ดทิ้งจากที่มีอยู่ได้เลย ไม่ต้องยิง API ซ้ำ */
  syncFromStore = () => {
    const uids = favList();
    const loaded = new Set(this.state.items.map((item) => item.id));

    if (uids.some((uid) => !loaded.has(uid))) return this.Get();
    this.setState((state) => ({ items: state.items.filter((item) => uids.includes(item.id)) }));
  };

  soon = (name) => alert("", "info", t("coming_soon_title"), `${name} — ${t("coming_soon_desc")}`, t("confirm"));

  openProperty = (item) => window.open(`/property/${item.id}`, "_blank", "noopener,noreferrer");

  /* กดหัวใจในหน้านี้มีทางเดียวคือเอาออก การ์ดจึงหายทันทีผ่าน syncFromStore
     (ไม่ต้องเล่น effect เด้งเหมือนหน้าอื่น เพราะการ์ดที่จะเด้งกำลังจะหายไปอยู่แล้ว) */
  remove = (uid) => favToggle(uid);

  clear = async () => {
    const confirmed = await alert("", "warning", t("home_favorites"), t("home_favorites_clear_confirm"), t("confirm"), t("cancel"));
    if (confirmed) favClear();
  };

  render() {
    const { items, contact, ready } = this.state;

    return (
      <div className="mn-home">
        {/* อยู่หน้ารายการโปรดอยู่แล้ว กดปุ่มบนเมนูซ้ำจึงพากลับขึ้นบน ไม่เปิดแท็บซ้อน */}
        <HomeNavbar
          onPost={openFreePost}
          onFavorite={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        />

        <section className="hm-pl">
          <div className="hm-container">
            <div className="hm-pl__head">
              <h1 className="hm-pl__title">{t("home_favorites")}</h1>
              <span className="hm-pl__count">
                {ready ? t("home_favorites_count").replace("{n}", items.length.toLocaleString()) : ""}
              </span>
              {!!items.length && (
                <button type="button" className="hm-btn hm-btn--ghost hm-btn--sm" onClick={this.clear}>
                  {t("home_favorites_clear")}
                </button>
              )}
            </div>

            {items.length ? (
              <div className="hm-grid hm-grid--list">
                {items.map((item) => (
                  /* ทุกใบในหน้านี้คือของที่บันทึกไว้ หัวใจจึงติดสีเสมอ — กดคือเอาออก */
                  <HomePropertyCard key={item.id} item={item} favorite onFavorite={this.remove} onOpen={this.openProperty} />
                ))}
              </div>
            ) : (
              ready && (
                <div className="text-center py-5">
                  <div className="hm-muted mb-3">{t("home_favorites_empty")}</div>
                  <button
                    type="button"
                    className="hm-btn hm-btn--primary"
                    onClick={() => this.props.router.navigate("/properties")}
                  >
                    {t("home_favorites_browse")}
                  </button>
                </div>
              )
            )}
          </div>
        </section>

        <HomeFooter
          data={contact?.footer || {}}
          socials={contact?.socials || []}
          onLink={(key) => this.soon(t(key))}
          onSubscribe={() => this.soon(t("home_footer_subscribe"))}
        />
      </div>
    );
  }
}

export default withRouter(FavoriteList);
